import React from 'react'
import { BudgetFormProvider } from '_views/budget-view-v2/hooks/use-budget-form'
import { ViewContent } from './components/ViewContent'

export function BudgetViewSimplified() {
  return (
    <BudgetFormProvider>
      <ViewContent />
    </BudgetFormProvider>
  )
}
